module.exports = __webpack_public_path__ + "static/assets/d336785651dff780bb39bfcc31b649e8.jpg";